module.exports = __webpack_public_path__ + "media/images/medal-silver-e5b9b6df8341d83fb190a000956033c3.svg";